<p-toast></p-toast>
<p-toolbar styleClass="">
  <ng-template pTemplate="left">
    <p-button label="New" icon="pi pi-plus" styleClass="p-button-success mr-2 hide-label" (onClick)="onCreateNewClient($event)" [disabled]="!personDoesNotChanged" pTooltip="Новый контакт" tooltipPosition="top"></p-button>
    <p-button label="Delete" icon="pi pi-trash" styleClass="p-button-danger hide-label" (onClick)="buttonClick($event)"
              [disabled]="true" pTooltip="Удалить контакт" tooltipPosition="top"></p-button>
  </ng-template>

  <ng-template pTemplate="right">
    <p-button label="Все" icon="pi pi-globe" styleClass="p-button-secondary mr-2 hide-label" (onClick)="openAllTabs($event)" pTooltip="Раскрыть все вкладки" tooltipPosition="top"></p-button>
    <p-button label="Имена " icon="pi pi-briefcase" styleClass="p-button-secondary mr-2 hide-label" (onClick)="openNamesTab($event)" pTooltip="Общая информация о контакте (имена, примечания)" tooltipPosition="top"></p-button>
    <p-button label="Компания" icon="pi pi-users" [disabled]="false" styleClass="p-button-secondary mr-2 hide-label" (onClick)="openCompanyTab($event)" pTooltip="Перейти к редактированию компании" tooltipPosition="top"></p-button>
    <p-button label="Телефоны" icon="pi pi-cloud" [disabled]="false" styleClass="p-button-secondary mr-2 hide-label" (onClick)="openPhonesTab($event)" pTooltip="Перейти к редактированию телефонов" tooltipPosition="top"></p-button>
    <p-button label="Адрес" icon="pi pi-share-alt" [disabled]="false" styleClass="p-button-secondary mr-6 hide-label" (onClick)="openAddressTab($event)" pTooltip="Перейти к редактированию адреса" tooltipPosition="top"></p-button>

    <!--<p-fileUpload mode="basic" accept="image/*" [maxFileSize]="1000000" label="Import" chooseLabel="Import" class="mr-2 p-d-inline-block"></p-fileUpload>-->
    <p-button label="Export" icon="pi pi-upload" styleClass="p-button-info mr-2 hide-label" pTooltip="Сохранить данные о контакте" tooltipPosition="top"></p-button>
    <!--<p-button [label]="Save" icon="pi pi-save" class="p-button-success" (onClick)="buttonSaveAllClick($event)"
              [disabled]="(clientDoesNotChanged && departmentDoesNotChanged && personDoesNotChanged)" pTooltip="Сохранить изменения" tooltipPosition="top"></p-button>-->
  </ng-template>
</p-toolbar>

<!--
  tabNamesSelected: boolean = true;
  tabCompanySelected: boolean = true;
  tabPhonesSelected: boolean = false;
  tabAddressSelected: boolean = false;

       [PERSID] = <PERSID, int,>
      ,[PERSCLIID] = <PERSCLIID, int,>
      ,[PERSONDEPT] = <PERSONDEPT, int,>
      ,[PERSONIDCODE] = <PERSONIDCODE, char(16),>
      ,[PERSONFNAME] = <PERSONFNAME, varchar(64),>
      ,[PERSONMNAME] = <PERSONMNAME, varchar(64),>
      ,[PERSONLNAME] = <PERSONLNAME, varchar(64),>
      ,[PERSONPHONE] = <PERSONPHONE, varchar(32),>
      ,[PERSONFAX] = <PERSONFAX, varchar(32),>
      ,[PERSONCPHONE] = <PERSONCPHONE, varchar(32),>
      ,[PERSONPHONE1] = <PERSONPHONE1, varchar(32),>
      ,[PERSONFAX1] = <PERSONFAX1, varchar(32),>
      ,[PERSONNOTE] = <PERSONNOTE, varchar(255),>
      ,[PERSONNOTE1] = <PERSONNOTE1, varchar(255),>
      ,[PERSONTITLE] = <PERSONTITLE, varchar(64),>
      ,[PERSONCOUNTRY] = <PERSONCOUNTRY, varchar(128),>
      ,[PERSONCITY] = <PERSONCITY, varchar(128),>
      ,[PERSONADDR1] = <PERSONADDR1, varchar(128),>
      ,[PERSONADDR2] = <PERSONADDR2, varchar(128),>
      ,[PERSONEMAIL] = <PERSONEMAIL, varchar(128),>
      ,[PERSONINDEX] = <PERSONINDEX, varchar(32),>
      ,[PERSPASSWORD] = <PERSPASSWORD, varchar(32),>
      ,[PERSSESSIONID] = <PERSSESSIONID, varchar(32),>
      ,[PERSSESSTIME] = <PERSSESSTIME, datetime,>
      ,[PERSRESPONSIBLE] = <PERSRESPONSIBLE, int,>
      ,[PERSSIGNID] = <PERSSIGNID, int,>

-->

<div *ngIf="person as per else loading">
  <p-accordion [multiple]="true" (onOpen)="onTabOpen($event)">
    <p-accordionTab [selected]="tabNamesSelected" styleClass="" [cache]="false">
      <ng-template pTemplate="header">
        <h3>Контактная информация: {{per.PERSONLNAME | pipetrimstr }} {{per.PERSONFNAME | pipetrimstr }} {{per.PERSONMNAME | pipetrimstr }} ({{_perId}})</h3>
      </ng-template>
      <div class="fluid formgrid grid" appStopAccordionHomeEnd>
        <div class="field col-4 xl:col-4 sm:col-12">
          <label for="PR1" class="do-not-wrap-text">Фамилия</label>
          <input id="PR1" type="text" pInputText [(ngModel)]="per.PERSONLNAME" required />
        </div>
        <div class="field col-4 xl:col-4 sm:col-12">
          <label for="PR2" class="do-not-wrap-text">Имя</label>
          <input id="PR2" type="text" pInputText [(ngModel)]="per.PERSONFNAME" required />
        </div>
        <div class="field col-4 xl:col-4 sm:col-12">
          <label for="PR3" class="do-not-wrap-text">Отчество</label>
          <input id="PR3" type="text" pInputText [(ngModel)]="per.PERSONMNAME" required />
        </div>
        <div class="field col-3 xl:col-3 sm:col-12">
          <label for="PR4" class="do-not-wrap-text">ИНН</label>
          <p-inputMask id="PR4" [(ngModel)]="per.PERSONIDCODE" autoClear="false" mask="9999999999?999" [style]="{'width':'100%'}"></p-inputMask>
        </div>
        <div class="field col-3 xl:col-3 sm:col-12">
          <label for="PR5" class="do-not-wrap-text">Мобильный телефон</label>
          <p-inputMask id="PR5" [(ngModel)]="per.PERSONCPHONE" autoClear="false" mask="(999)999-9999" [style]="{'width':'100%'}"></p-inputMask>
        </div>
        <div class="field col-3 xl:col-3 sm:col-12">
          <label for="PR6" class="do-not-wrap-text">E-mail</label>
          <input id="PR6" type="text" pInputText [(ngModel)]="per.PERSONEMAIL" />
        </div>
        <div class="field col-3 xl:col-3 sm:col-12" *ngIf="canManageTeamsIdentity && isLocalCompanyContact && _perId > 0">
          <label for="PRTG" class="do-not-wrap-text">Teams GUID (агент)</label>
          <ng-container *ngIf="teamsIdentityLoaded; else teamsIdentityLoading">
            <div class="p-inputgroup">
              <input id="PRTG" type="text" pInputText [(ngModel)]="teamsIdentity.teams_user_id"
                     placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx" [disabled]="teamsIdentitySaving" />
              <p-button icon="pi pi-check" styleClass="p-button-success ml-1" (onClick)="saveTeamsIdentity()"
                      [disabled]="!teamsIdentityValid || teamsIdentitySaving" pTooltip="Зберегти Teams GUID" tooltipPosition="top"></p-button>
            </div>
            <p-checkbox name="PRTGActive" label="Активний учасник команди агента" [binary]="true" styleClass="mt-2"
                        [(ngModel)]="teamsIdentityActiveDisplay" [disabled]="teamsIdentitySaving || !teamsIdentityValid"
                        pTooltip="Потрібен валідний Teams GUID" tooltipPosition="top" [tooltipDisabled]="teamsIdentityValid"></p-checkbox>
          </ng-container>
          <ng-template #teamsIdentityLoading><small>Завантаження...</small></ng-template>
        </div>
        <div class="field col-12">
          <label for="PR7" class="do-not-wrap-text">Примечание</label>
          <input id="PR7" type="text" pInputText [(ngModel)]="per.PERSONNOTE" />
        </div>
        <div class="field col-12">
          <label for="PR8" class="do-not-wrap-text">Доп. информация</label>
          <input id="PR8" type="text" pInputText [(ngModel)]="per.PERSONNOTE1" />
        </div>
      </div>

      <div class="grid formgrid justify-content-end">
        <p-button label="Сохранить" icon="pi pi-check" (onClick)="onConfirm(1)" styleClass="mr-2" [disabled]="personDoesNotChanged"></p-button>
      </div>
    </p-accordionTab>

    <p-accordionTab [selected]="tabCompanySelected" styleClass="" [cache]="false" [disabled]="false">
      <ng-template pTemplate="header">
        <h5>Компания</h5>
      </ng-template>
      <div class="fluid formgrid grid" appStopAccordionHomeEnd>
        <div class="field col-12 xl:col-6 sm:col-12">
          <app-companyselector labelKey="Организация {{_perId}}" [parentCompany]="0"
                               [selectedID]="per.PERSCLIID" (selectedCompanyID)="onCompanySelected($event)" [disabled]="_perId"></app-companyselector>
        </div>
        <div class="field col-12 xl:col-6 sm:col-12">
          <app-departmentselector labelKey="Отдел" [parentCompany]="per.PERSCLIID" [selectedID]="per.PERSONDEPT"
                                  (selectedDepartmentID)="onDepartmentSelected($event)"></app-departmentselector>
        </div>
        <div class="field col-12 xl:col-6 sm:col-12">
          <label for="PR9" class="do-not-wrap-text">Должность</label>
          <input id="PR9" type="text" pInputText [(ngModel)]="per.PERSONTITLE" />
        </div>
        <div class="field col-12 xl:col-6 sm:col-12">
          <label for="PRP" class="do-not-wrap-text">Ответственность</label>
          <p-dropdown id="PRP" [options]="personResponsibilityList" [(ngModel)]="per.PERSRESPONSIBLE" optionLabel="value" [autofocusFilter]="false" optionValue="index"></p-dropdown>
        </div>
      </div>

      <div class="grid formgrid justify-content-end">
        <p-button label="Сохранить" icon="pi pi-check" (onClick)="onConfirm(1)" styleClass="mr-2" [disabled]="personDoesNotChanged"></p-button>
      </div>
    </p-accordionTab>
    <p-accordionTab [selected]="tabPhonesSelected" styleClass="" [cache]="false" [disabled]="false">
      <ng-template pTemplate="header">
        <h5>Телефоны</h5>
      </ng-template>
      <div class="fluid formgrid grid" appStopAccordionHomeEnd>
        <div class="field col-6 xl:col-6 sm:col-12">
          <label for="PRF1" class="do-not-wrap-text">Рабочий телефон</label>
          <p-inputMask id="PRF1" [(ngModel)]="per.PERSONPHONE" autoClear="false" mask="(999)999-9999" [style]="{'width':'100%'}"></p-inputMask>
        </div>
        <div class="field col-6 xl:col-6 sm:col-12">
          <label for="PRF2" class="do-not-wrap-text">Рабочий телефон 2</label>
          <p-inputMask id="PRF2" [(ngModel)]="per.PERSONPHONE1" autoClear="false" mask="(999)999-9999" [style]="{'width':'100%'}"></p-inputMask>
        </div>
        <div class="field col-6 xl:col-6 sm:col-12">
          <label for="PRF3" class="do-not-wrap-text">Рабочий телефон/факс</label>
          <p-inputMask id="PRF3" [(ngModel)]="per.PERSONFAX" autoClear="false" mask="(999)999-9999" [style]="{'width':'100%'}"></p-inputMask>
        </div>
        <div class="field col-6 xl:col-6 sm:col-12">
          <label for="PRF4" class="do-not-wrap-text">Рабочий телефон/факс 2</label>
          <p-inputMask id="PRF4" [(ngModel)]="per.PERSONFAX1" autoClear="false" mask="(999)999-9999" [style]="{'width':'100%'}"></p-inputMask>
        </div>
      </div>
      <div class="grid formgrid justify-content-end">
        <p-button label="Сохранить" icon="pi pi-check" (onClick)="onConfirm(1)" styleClass="mr-2" [disabled]="personDoesNotChanged"></p-button>
      </div>
    </p-accordionTab>
    <p-accordionTab [selected]="tabAddressSelected" styleClass="" [cache]="false" [disabled]="false">
      <ng-template pTemplate="header">
        <h5>Адрес</h5>
      </ng-template>
      <div class="fluid formgrid grid" appStopAccordionHomeEnd>
        <div class="field col-12 xl:col-4 sm:col-12">
          <label for="CA1" class="do-not-wrap-text">Почтовый индекс</label>
          <input id="CA1" type="text" pInputText [(ngModel)]="per.PERSONINDEX" />
        </div>
        <div class="field col-12 xl:col-4 sm:col-12">
          <label for="CA2" class="do-not-wrap-text">Страна</label>
          <input id="CA2" type="text" pInputText [(ngModel)]="per.PERSONCOUNTRY" />
        </div>
        <div class="field col-12 xl:col-4 sm:col-12">
          <label for="CA3" class="do-not-wrap-text">Город</label>
          <input id="CA3" type="text" pInputText [(ngModel)]="per.PERSONCITY" class="" />
        </div>
        <div class="field col-12 xl:col-6 sm:col-12">
          <label for="CA4" class="do-not-wrap-text">Адрес</label>
          <input id="CA4" type="text" pInputText [(ngModel)]="per.PERSONADDR1" />
        </div>
        <div class="field col-12 xl:col-6 sm:col-12">
          <label for="CA5" class="do-not-wrap-text">Доп адрес</label>
          <input id="CA5" type="text" pInputText [(ngModel)]="per.PERSONADDR2" />
        </div>
      </div>
      <div class="grid formgrid justify-content-end">
        <p-button label="Сохранить" icon="pi pi-check" (onClick)="onConfirm(1)" styleClass="mr-2" [disabled]="personDoesNotChanged"></p-button>
      </div>
    </p-accordionTab>

    <p-accordionTab [selected]="tabSignSelected" styleClass="" [cache]="false" [disabled]="false">
      <ng-template pTemplate="header">
        <h5>Підпис</h5>
      </ng-template>
      <div class="flex flex-column align-items-center gap-3 p-3">
        <img *ngIf="signatureDataUrl"
             [src]="signatureDataUrl" alt="Підпис"
             style="max-width:300px; max-height:150px; border:1px solid #ddd; border-radius:4px; object-fit:contain; background:#fff;">
        <span *ngIf="!signatureDataUrl" class="text-500">Підпис не завантажено</span>
        <div class="flex gap-2">
          <label class="p-button p-button-sm p-button-outlined"
                 [class.p-disabled]="signatureUploading || !_perId || _perId <= 0">
            <i class="pi pi-upload mr-1"></i> Завантажити підпис
            <input type="file" accept="image/*" style="display:none"
                   [disabled]="signatureUploading || !_perId || _perId <= 0"
                   (change)="onSignFileSelected($event)">
          </label>
          <p-button *ngIf="signatureDataUrl" icon="pi pi-trash" label="Видалити"
                    styleClass="p-button-sm p-button-danger p-button-outlined"
                    [loading]="signatureUploading"
                    (onClick)="onSignDelete()">
          </p-button>
        </div>
        <small class="text-500">PNG, JPG, GIF — максимум 2 МБ. Підпис використовується в документах JSReport.</small>
      </div>
    </p-accordionTab>
  </p-accordion>
</div>
<ng-template #loading>
  <p>Информация загружается...</p>
</ng-template>
